import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.netural100};
  margin-top: 4rem;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 2px 0px rgba(24, 30, 45, 0.05),
    0px 0px 10px 0px rgba(64, 56, 95, 0.05),
    0px 0px 40px 0px rgba(81, 94, 108, 0.05);
  border-radius: 8px;
  padding: 40px;
  width: 646px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
    padding: 20px;
  }
`;

export const Title = styled.h2`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 34px;
  color: ${({ theme }) => theme.colors.primary600};
  text-align: center;
  margin-bottom: 16px;
`;

export const Description = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.netural800};
  text-align: center;
  margin-bottom: 32px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 476px;
  max-width: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
  }
`;

export const Label = styled.label`
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 6px;
`;

export const Input = styled.input`
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.colors.netural300};
  border-radius: 6px;
  font-size: 15px;
  width: 100%;
`;

export const Select = styled.select`
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.colors.netural300};
  border-radius: 6px;
  font-size: 15px;
  width: 100%;
`;